import type { AmlReview } from '@/integrations/Immersve/aml-review/types';
import type { QueueRowData } from './queueRow';

function recommendationFromStatus(status: string): QueueRowData['recommendation'] {
  if (status === 'created') return 'CREATED';
  if (status === 'requested') return 'PROCESSING';
  if (status === 'escalated') return 'REVIEW';
  if (status === 'complete') return 'COMPLETE';
  if (status === 'canceled') return 'CANCELED';
  return undefined;
}

export function mapAmlReviewToRow(review: AmlReview): QueueRowData {
  const nameParts = review.identityDetails?.name;
  const name =
    [nameParts?.givenName, nameParts?.middleName, nameParts?.familyName]
      .filter(Boolean)
      .join(' ') || review.externalProfileId;

  const hits = review.amlHits ?? [];
  const openHits = hits.filter((hit) => hit.status !== 'false_positive');

  return {
    id: review.amlReviewId,
    name,
    externalId: review.externalProfileId,
    partner: review.partnerName,
    provider: review.kycProvider,
    region: review.region,
    recommendation: recommendationFromStatus(review.status),
    hitsTotal: hits.length,
    hitsOpen: openHits.length,
    hitTypes: [...new Set(openHits.flatMap((hit) => hit.hitTypes))],
    createdAt: review.createdAt,
  };
}
